import type { ErrorCopyFor } from "@amtana/browser";
import type { FINDER_ERROR_CODES } from "@amtana/finder-contract";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a user reads when the account finder fails (packages/module ADR-001).

const EN = {
  accountNotFoundTitle: "This account isn't in the finder",
  accountNotFoundDescription: "It may have been removed. Search again to find similar accounts.",
  searchNotFoundTitle: "This saved search doesn't exist",
  searchNotFoundDescription: "It may have been deleted. Open your saved searches to pick another.",
  aiUnparsedTitle: "We couldn't turn that into filters",
  aiUnparsedDescription: "Mention a niche, an audience size, a country or a contact you need.",
} as const;

const ES: Translation<typeof EN> = {
  accountNotFoundTitle: "Esta cuenta no está en el buscador",
  accountNotFoundDescription: "Puede que se haya quitado. Busca de nuevo para encontrar cuentas similares.",
  searchNotFoundTitle: "Esta búsqueda guardada no existe",
  searchNotFoundDescription: "Puede que se haya eliminado. Abre tus búsquedas guardadas para elegir otra.",
  aiUnparsedTitle: "No pudimos convertir eso en filtros",
  aiUnparsedDescription: "Menciona un nicho, el tamaño de la audiencia, un país o un contacto que necesitas.",
};

export const FINDER_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const FINDER_ERROR_COPY = {
  finder_account_not_found: {
    title: phrase(FINDER_ERROR_CATALOGS, "accountNotFoundTitle"),
    description: phrase(FINDER_ERROR_CATALOGS, "accountNotFoundDescription"),
  },
  finder_search_not_found: {
    title: phrase(FINDER_ERROR_CATALOGS, "searchNotFoundTitle"),
    description: phrase(FINDER_ERROR_CATALOGS, "searchNotFoundDescription"),
  },
  finder_ai_unparsed: {
    title: phrase(FINDER_ERROR_CATALOGS, "aiUnparsedTitle"),
    description: phrase(FINDER_ERROR_CATALOGS, "aiUnparsedDescription"),
  },
} satisfies ErrorCopyFor<typeof FINDER_ERROR_CODES>;
